/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class StartTimeDateFilters {
  /**
  * Matches if `startTime` is on or later than this date. Must be in ISO 8601 YYYY-MM-DD format. 
  */
  'startDate'?: string;
  /**
  * Matches if `startTime` is on or earlier than this date. Must be in ISO 8601 YYYY-MM-DD format. 
  */
  'endDate'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "startDate",
      "baseName": "startDate",
      "type": "string",
      "format": ""
    },
    {
      "name": "endDate",
      "baseName": "endDate",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return StartTimeDateFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

